import { render, staticRenderFns } from "./Wp_jd_request.vue?vue&type=template&id=227d1830&scoped=true&"
import script from "./Wp_jd_request.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_request.vue?vue&type=script&lang=js&"
import style0 from "./Wp_jd_request.vue?vue&type=style&index=0&id=227d1830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d1830",
  null
  
)

export default component.exports